export function updateStep1Action(
  state: any,
  payload: {
    industry: any;
    jobCategory: any;
    jobTitle: any;
    positionType: any;
    location: any;
    jobLocation: {
      onSite: any;
      remote: any;
      hybrid: any;
    };
    progressStep: any;
  }
) {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload,
    },
  };
}
